(function () {
  'use strict';
  if (customElements.get('dhs-welcome-popup')) return;
  var SELECTED_KEY = 'dhs_welcome_popup_discount_selected';
  var DISMISSED_KEY = 'dhs_welcome_popup_dismissed';
  var SESSION_KEY = 'dhs_welcome_popup_session_closed';
  var START_KEY = 'dhs_welcome_popup_visit_started';
  function read(storage, key) { try { return storage.getItem(key); } catch (error) { return null; } }
  function write(storage, key, value) { try { storage.setItem(key, value); } catch (error) {} }
  // Storage getters can themselves throw when browser storage is blocked.
  function storage(kind) { try { return window[kind]; } catch (error) { return { getItem: function () {}, setItem: function () {} }; } }
  customElements.define('dhs-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      var signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.editor = Boolean(window.Shopify && window.Shopify.designMode);
      this.closedThisPage = false;
      this.closing = false;
      this.waitingForCookies = false;
      var self = this;
      this.addEventListener('click', function (event) {
        if (event.target.closest('[data-popup-dismiss]')) self.dismiss();
        if (self.editor && event.target.closest('[data-welcome-discount-activate]')) {
          // Do not change Shopify's real discount state while editing a preview.
          event.preventDefault();
          event.stopPropagation();
          self.querySelector('.dhs-popup__editor-note').hidden = false;
        }
        if (event.target === self.dialog) {
          var bounds = self.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) self.dismiss();
        }
      }, { signal: signal });
      this.dialog.addEventListener('cancel', function (event) { event.preventDefault(); self.dismiss(); }, { signal: signal });
      document.addEventListener('welcome-discount:activated', function () {
        if (!self.editor) self.rememberActivation();
      }, { signal: signal });
      document.addEventListener('click', function (event) {
        if (self.editor || !(event.target instanceof Element)) return;
        var removeButton = event.target.closest('button[is="cart-discount-remove"]');
        var discountItem = removeButton && removeButton.closest('[data-discount-code]');
        if (discountItem && String(discountItem.dataset.discountCode || '').trim().toUpperCase() === 'WELKOM15') self.rememberActivation();
      }, { capture: true, signal: signal });
      document.addEventListener('shopify:section:select', function (event) {
        if (!self.editor) return;
        if (event.target.contains(self) && self.dataset.editorPreview === 'true') self.open(true);
        else self.close();
      }, { signal: signal });
      document.addEventListener('shopify:section:deselect', function (event) {
        if (self.editor && event.target.contains(self)) self.close();
      }, { signal: signal });
      this.observer = new MutationObserver(function () {
        if (!self.editor && document.documentElement.classList.contains('welcome-discount-active')) self.rememberActivation();
      });
      this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.cookieObserver = new MutationObserver(function () {
        if (!self.editor && self.dialog.open && self.cookieBannerVisible()) {
          self.waitingForCookies = true;
          self.close(true);
          clearTimeout(self.timer);
          self.timer = setTimeout(function () { self.attemptOpen(); }, 300);
        }
      });
      this.cookieObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      if (this.editor) {
        if (this.dataset.editorPreview === 'true') this.timer = setTimeout(function () { self.open(true); }, 150);
        return;
      }
      if (document.documentElement.classList.contains('welcome-discount-active')) this.rememberActivation();
      if (!this.eligible()) return;
      if (!this.cookiesReady()) {
        this.waitingForCookies = true;
        this.timer = setTimeout(function () { self.attemptOpen(); }, 300);
        return;
      }
      var sessionStorage = storage('sessionStorage');
      var started = Number(read(sessionStorage, START_KEY));
      if (!started) { started = Date.now(); write(sessionStorage, START_KEY, String(started)); }
      var remaining = Math.max(0, Number(this.dataset.delay) * 1000 - (Date.now() - started));
      this.timer = setTimeout(function () { self.attemptOpen(); }, remaining);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.close(true);
      if (this.cookieObserver) this.cookieObserver.disconnect();
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    eligible() {
      if (this.closedThisPage || this.dataset.enabled !== 'true' || this.dataset.customerEligible !== 'true') return false;
      if (document.documentElement.classList.contains('welcome-discount-active')) return false;
      var scope = this.dataset.pageScope;
      if (scope === 'home' && this.dataset.pageType !== 'index') return false;
      if (scope === 'shopping' && ['product', 'collection'].indexOf(this.dataset.pageType) === -1) return false;
      var path = location.pathname.replace(/\/$/, '') || '/';
      var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      if (routeRoot !== '/' && path.indexOf(routeRoot.replace(/\/$/, '') + '/') === 0) path = '/' + path.slice(routeRoot.length);
      var excluded = (this.dataset.excludedPaths || '').split(/\r?\n/).some(function (line) {
        var value = line.trim().replace(/\/$/, '');
        return value && (path === value || path.indexOf(value + '/') === 0);
      });
      if (excluded) return false;
      if (read(storage('localStorage'), SELECTED_KEY)) return false;
      if (read(storage('sessionStorage'), SESSION_KEY) === 'true') return false;
      var dismissed = Number(read(storage('localStorage'), DISMISSED_KEY));
      if (dismissed && (this.dataset.repeat === 'never' || (this.dataset.repeat !== 'session' && Date.now() - dismissed < Number(this.dataset.repeat) * 86400000))) return false;
      return true;
    }
    cookieBannerVisible() {
      return Array.from(document.querySelectorAll('#stcm-banner, #stcm-modal')).some(function (node) {
        var style = window.getComputedStyle(node);
        return !node.hidden && style.display !== 'none' && style.visibility !== 'hidden';
      });
    }
    cookiesReady() {
      // Silktide is initialized on window.load in this theme.
      if (document.querySelector('script[src*="silktide-consent-manager.js"]')) {
        if (document.readyState !== 'complete') return false;
        var manager = window.silktideConsentManager;
        if (!manager || !manager.getInstance || !manager.getInstance()) return false;
      }
      return !this.cookieBannerVisible();
    }
    attemptOpen() {
      if (!this.isConnected || !this.eligible()) return;
      var self = this;
      if (!this.cookiesReady()) {
        this.waitingForCookies = true;
        this.cookieResumeAt = null;
        this.timer = setTimeout(function () { self.attemptOpen(); }, 300);
        return;
      }
      if (this.waitingForCookies) {
        if (!this.cookieResumeAt) this.cookieResumeAt = Date.now() + Number(this.dataset.delay) * 1000;
        if (Date.now() < this.cookieResumeAt) {
          this.timer = setTimeout(function () { self.attemptOpen(); }, this.cookieResumeAt - Date.now());
          return;
        }
        this.waitingForCookies = false;
        this.cookieResumeAt = null;
      }
      // Wait until another theme dialog/drawer has closed; avoid overlapping controls.
      var otherOverlay = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer[open], quick-view[open]')).some(function (node) {
        return node !== this.dialog && node.getClientRects().length > 0;
      }, this);
      if (otherOverlay || document.hidden) {
        var self = this;
        this.timer = setTimeout(function () { self.attemptOpen(); }, 1000);
        return;
      }
      this.open(false);
    }
    open(preview) {
      if (!this.dialog || (!preview && !this.eligible())) return;
      if (this.dialog.open && !this.closing) return;
      if (typeof this.dialog.showModal !== 'function') return;
      clearTimeout(this.closeTimer);
      this.closing = false;
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.getBoundingClientRect();
      var self = this;
      this.openFrame = requestAnimationFrame(function () {
        self.dialog.classList.add('is-visible');
      });
    }
    close(immediate) {
      cancelAnimationFrame(this.openFrame);
      if (!this.dialog) return;
      if (immediate) {
        clearTimeout(this.closeTimer);
        this.dialog.classList.remove('is-visible');
        if (this.dialog.open) this.dialog.close();
        this.closing = false;
        return;
      }
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      this.dialog.classList.remove('is-visible');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var duration = reduced ? 0 : Number(this.dataset.animationDuration || 350);
      var self = this;
      this.closeTimer = setTimeout(function () {
        if (self.dialog.open) self.dialog.close();
        self.closing = false;
      }, duration);
    }
    rememberActivation() {
      if (this.editor) return;
      // Selecting the discount is a completed interaction, even after removing it.
      // This is separate from the configurable cooldown after simply dismissing.
      this.closedThisPage = true;
      clearTimeout(this.timer);
      if (!read(storage('localStorage'), SELECTED_KEY)) write(storage('localStorage'), SELECTED_KEY, String(Date.now()));
      write(storage('sessionStorage'), SESSION_KEY, 'true');
      this.close();
    }
    dismiss() {
      if (!this.editor) {
        this.closedThisPage = true;
        clearTimeout(this.timer);
        write(storage('localStorage'), DISMISSED_KEY, String(Date.now()));
        write(storage('sessionStorage'), SESSION_KEY, 'true');
      }
      this.close();
    }
  });
})();
